import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "../../../EaseApp/index";
import { Menu, MenuItem, IconButton, Icon, InputBase } from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles, fade } from "@material-ui/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import i18next from "i18next";
import MessageActions from "../../../redux/message";
import SessionActions from "../../../redux/session";
import GlobalPropsActions from "../../../redux/globalProps";
import WebIM from "../../../utils/WebIM";
import _ from 'lodash';
import avatarIcon1 from '../../../common/images/avatar1.png';
import avatarIcon2 from '../../../common/images/avatar2.png';
import avatarIcon3 from '../../../common/images/avatar3.png';
import groupAvatarIcon from '../../../common/images/groupAvatar.png';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      zIndex: "999",
      width: "100%",
      height: "6.67vh",
      maxHeight: "60px",
      minHeight: "40px",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 10px"
    },
    leftBar: {
      display: "flex",
      alignItems: "center"
    },
    avatar: {
      margin: "0 20px 0 16px"
    }
  };
});

var MessageBar = function MessageBar() {
  var classes = useStyles();
  var dispatch = useDispatch();
  var groupById = useSelector(function (state) {
    var _state$group;

    return (_state$group = state.group) === null || _state$group === void 0 ? void 0 : _state$group.group.byId;
  }) || {};
  var globalProps = useSelector(function (state) {
    return state.global.globalProps;
  });

  var _useState = useState(null),
      sessionEl = _useState[0],
      setSessionEl = _useState[1];

  var chatType = globalProps.chatType,
      to = globalProps.to,
      username = globalProps.username;

  var renderSessionInfoMenu = function renderSessionInfoMenu() {
    var handleClickClearMessage = function handleClickClearMessage() {
      dispatch(MessageActions.clearMessage(chatType, to));
    };

    var handleClickDeleteSession = function handleClickDeleteSession() {
      dispatch(MessageActions.clearMessage(chatType, to));
      dispatch(SessionActions.deleteSession(to));
      dispatch(GlobalPropsActions.setGlobalProps({
        to: null
      }));
    };

    return /*#__PURE__*/React.createElement(Menu, {
      id: "simple-menu",
      anchorEl: sessionEl,
      keepMounted: true,
      open: Boolean(sessionEl),
      onClose: function onClose() {
        return setSessionEl(null);
      }
    }, /*#__PURE__*/React.createElement(MenuItem, {
      onClick: handleClickClearMessage
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.menuItemIconBox
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "iconfont icon-qingkongxiaoxi"
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "inherit",
      noWrap: true
    }, i18next.t("Clear Message"))), /*#__PURE__*/React.createElement(MenuItem, {
      onClick: handleClickDeleteSession
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.menuItemIconBox
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "iconfont icon-shanchuhuihua"
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "inherit",
      noWrap: true
    }, i18next.t("Delete Session"))));
  };

  var handleSessionInfoClick = function handleSessionInfoClick(e) {
    setSessionEl(e.currentTarget);
  };

  var userAvatars = {
    1: avatarIcon1,
    2: avatarIcon2,
    3: avatarIcon3
  };

  var _useState2 = useState([]),
      userAvatarIndex = _useState2[0],
      setUserAvatarIndex = _useState2[1];

  var _useState3 = useState([]),
      usersInfoData = _useState3[0],
      setUsersInfoData = _useState3[1];

  useEffect(function () {
    var _$find;

    var newwInfoData = usersInfoData && usersInfoData.length > 0 ? usersInfoData : localStorage.getItem("usersInfo_1.0");
    setUsersInfoData(newwInfoData);
    setUserAvatarIndex(((_$find = _.find(newwInfoData, {
      username: to
    })) === null || _$find === void 0 ? void 0 : _$find.userAvatar) || 1);
  }, [to]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Box, {
    position: "static",
    className: classes.leftBar
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: classes.avatar,
    src: chatType === "singleChat" ? userAvatars[userAvatarIndex] : groupAvatarIcon,
    style: {
      borderRadius: chatType === "singleChat" ? "50%" : 'inherit'
    }
  }), to), /*#__PURE__*/React.createElement(Box, {
    position: "static"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleSessionInfoClick,
    className: "iconfont icon-hanbaobao icon"
  })), renderSessionInfoMenu());
};

export default MessageBar;